import { API_RESOURCE } from '@/constants/api.constant'
import OfferGCPRService from '@/features/offers/services/offerGCPR.service'
import useAction from '@/hooks/useAction'
import { createQueryKey } from '@/lib/react-query'

const useOfferGCPR = () => {
  const service = new OfferGCPRService()
  const queryKey = createQueryKey(API_RESOURCE.OFFER)

  const useSubmitGCMaterialPR = useAction({
    mutationFn: service.submitGCMaterialPR,
    queryKey: queryKey,
    message: 'Successfully Submit GC Material PR',
  })
  const useUpdateGCMaterialPR = useAction({
    mutationFn: service.updateGCMaterialPR,
    queryKey: queryKey,
    message: 'Successfully Updated GC Material PR',
  })
  const useApproveGCMaterialPR = useAction({
    mutationFn: service.approveGCMaterialPR,
    queryKey: queryKey,
    message: 'Successfully Approve GC Material PR',
  })
  const useRejectGCMaterialPR = useAction({
    mutationFn: service.rejectGCMaterialPR,
    queryKey: queryKey,
    message: 'Successfully Reject GC Material PR',
  })
  const useResubmitGCMaterialPR = useAction({
    mutationFn: service.resubmitGCMaterialPR,
    queryKey: queryKey,
    message: 'Successfully Resubmit GC Material PR',
  })
  const useArchiveGCMaterialPR = useAction({
    mutationFn: service.archiveGCMaterialPR,
    queryKey: queryKey,
    message: 'Successfully Archived GC Material PR',
  })

  const useInviteGCPRUser = useAction({
    mutationFn: service.inviteGCPRUser,
    queryKey: queryKey,
    message: 'Successfully invited user to GCPR approval',
  })

  const useReplyGCPRInvitation = useAction({
    mutationFn: service.replyGCPRInvitation,
    queryKey: queryKey,
    message: 'Successfully replied to GCPR invitation',
  })

  const useDeleteGCPRInvitedUser = useAction({
    mutationFn: service.deleteGCPRInvitedUser,
    queryKey: queryKey,
    message: 'Successfully removed GCPR invited users',
  })
  const useBatchApproveGCPR = useAction({
    mutationFn: service.batchApproveGCPR,
    queryKey: queryKey,
    message: 'Successfully Batch Approve GCPR',
    shouldRefresh: false,
  })

  return {
    useSubmitGCMaterialPR,
    useUpdateGCMaterialPR,
    useApproveGCMaterialPR,
    useRejectGCMaterialPR,
    useResubmitGCMaterialPR,
    useArchiveGCMaterialPR,
    useInviteGCPRUser,
    useReplyGCPRInvitation,
    useDeleteGCPRInvitedUser,
    useBatchApproveGCPR,
  }
}

export default useOfferGCPR
